module.exports = __webpack_public_path__ + "media/images/emblems/Champvent-coat_of_arms-a9389cacd3b81fbe408f13a836818510.svg";